module.exports = __webpack_public_path__ + "img/demo-marketing-consultant-400x300.6a10fce0.jpg";